import api from 'api';

import { CPE_ID } from '../components/CostModel';

export const loadFilterStatuses = api('GET /api/campaigns/filters/statuses');

export const loadFilterTypes = api(
  'GET /api/campaigns/filters/targetingactivitytypes'
);

export const loadFilterAffiliates = api(
  'GET /api/campaigns/filters/affiliates'
);
export const loadFilterApplications = api(
  'GET /api/campaigns/filters/applications'
);
export const loadFilterFraudProtections = api(
  'POST /api/campaigns/filters/fraudprotections'
);
export const loadFilterNetworks = api('GET /api/campaigns/filters/networks');
export const loadFilterOwners = api('GET /api/campaigns/filters/owners');
export const loadFilterParentCampaignsOwners = api(
  'GET /api/parent-campaigns/filters/owners'
);
export const loadFilterPartnerCampaigns = api(
  'GET /api/campaigns/filters/partnercampaignidfilters'
);
export const loadFilterPlatforms = api('GET /api/campaigns/filters/platforms');
export const loadFilterPromoCodes = api(
  'GET /api/campaigns/filters/promocodefilters'
);

export const loadFilterCostModels = api(
  'GET /api/campaigns/filters/costs/types'
);
export const loadFilterCountries = api('GET /api/campaigns/filters/countries');
export const loadFilterLabels = api('GET /api/campaigns/filters/labels');

export const loadActivityTypes = api('GET /api/campaigns/fields/activitytypes');

export const loadCostModelsEventsFilter = api(
  `GET /api/campaigns/fields/events/${CPE_ID}`
);
